export default __webpack_public_path__ + "static/media/logo-light.1b4a360d.svg";